module.exports = __webpack_public_path__ + "img/sqlsfw.8662d7cb.jpg";